import { createContext, useContext, useEffect, useState } from "react"
import API_URL from "../config"

const AuthContext = createContext()

const readStoredAccount = () => {
  try {
    return JSON.parse(localStorage.getItem("cuenta") || "null")
  } catch {
    return null
  }
}

export const AuthProvider = ({ children }) => {
  const [account, setAccount] = useState(readStoredAccount)
  const [loading, setLoading] = useState(true)

  const storeAccount = (data) => {
    const nextAccount = {
      id: data.usuario_id,
      nombres: data.nombres || data.usuario,
      apellidos: data.apellidos || "",
      correo: data.correo,
      rol: data.rol,
      activo: data.activo,
      estado_acceso: data.estado_acceso || data.rol?.estado_acceso,
      imagen: data.imagen,
    }
    setAccount(nextAccount)
    localStorage.setItem("cuenta", JSON.stringify(nextAccount))
    localStorage.setItem("isAuthenticated", "true")
    localStorage.setItem("usuario", nextAccount.nombres || "")
    localStorage.setItem("correo", nextAccount.correo || "")
    localStorage.setItem("activo", String(nextAccount.activo !== false))
    localStorage.setItem("rolActual", JSON.stringify(nextAccount.rol || {}))
  }

  const clearAccount = () => {
    setAccount(null)
    ;["cuenta", "isAuthenticated", "usuario", "correo", "rolActual", "activo", "jwtToken"].forEach((key) => {
      localStorage.removeItem(key)
    })
  }

  useEffect(() => {
    let active = true
    fetch(`${API_URL}/sesion`, { credentials: "include" })
      .then(async (response) => {
        if (!active) return
        if (!response.ok) {
          clearAccount()
          return
        }
        storeAccount(await response.json())
      })
      .catch(() => {
        // No habilitar una sesión administrativa sin confirmación del servidor.
        if (active) clearAccount()
      })
      .finally(() => active && setLoading(false))

    return () => {
      active = false
    }
  }, [])

  const login = (data) => storeAccount(data || {})

  const logout = async () => {
    clearAccount()
    try {
      await fetch(`${API_URL}/logout`, { method: "POST", credentials: "include" })
    } catch {
      // La sesión local ya fue limpiada.
    }
  }

  const roleName = account?.rol?.nombre?.toUpperCase?.() || ""

  return (
    <AuthContext.Provider
      value={{
        account,
        isAuthenticated: Boolean(account && account.activo !== false),
        isClient: roleName === "CLIENTE",
        isAdmin: Boolean(account && roleName !== "CLIENTE"),
        login,
        logout,
        loading,
      }}
    >
      {children}
    </AuthContext.Provider>
  )
}

export const useAuth = () => {
  const context = useContext(AuthContext)
  if (context === undefined) throw new Error("useAuth must be used within an AuthProvider")
  return context
}
